function convertPoundsToGrams(num){
  let eq = 'Converting ' + num +" pounds to grams: \n"
+ num +" / 0.0022046 = ";
  let rep = num / 0.0022046;
  return eq + rep.toFixed(5);

}

function convertPoundsToOunces(num){
  let eq = 'Converting ' + num +" pounds to ounces: \n"+
    num+" * 16 = ";
    let rep = num * 16 ;
  return eq + rep.toFixed(2);
}

function convertPoundsToStones(num){
  let eq = 'Converting ' + num +" pounds to stones: \n"+
    num +" * 0.071429 = ";
  let rep = (num *  0.071429) ;
  return eq + rep.toFixed(4);
}

function convertPoundsToKilograms(num){
  let eq = 'Converting ' + num +" pounds to kilograms: \n"+
    num+" / 2.2046  = ";
  let rep = num / 2.2046;
  return eq + rep.toFixed(3);
}

export {
  convertPoundsToKilograms, convertPoundsToStones,
  convertPoundsToOunces, convertPoundsToGrams};
